/** Floating overlay showing AI thinking animation. */

let thinkTimer: ReturnType<typeof setTimeout> | null = null;

export function showThinkOverlay(duration = 0) {
  const el = document.getElementById("think-overlay");
  if (!el) return;

  el.style.display = "flex";
  el.classList.add("think-active");

  if (thinkTimer) clearTimeout(thinkTimer);

  if (duration > 0) {
    thinkTimer = setTimeout(() => {
      hideThinkOverlay();
    }, duration);
  }
}

export function hideThinkOverlay() {
  const el = document.getElementById("think-overlay");
  if (!el) return;

  el.classList.remove("think-active");
  setTimeout(() => {
    el.style.display = "none";
  }, 300);
}
